import { render, staticRenderFns } from "./PartsCatalogueItemListView.vue?vue&type=template&id=42e45e74"
import script from "./PartsCatalogueItemListView.vue?vue&type=script&lang=js"
export * from "./PartsCatalogueItemListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports